import { render, staticRenderFns } from "./StockFifoProductConfigurations.vue?vue&type=template&id=8fc2cf68&scoped=true&"
import script from "./StockFifoProductConfigurations.vue?vue&type=script&lang=js&"
export * from "./StockFifoProductConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./StockFifoProductConfigurations.vue?vue&type=style&index=0&id=8fc2cf68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc2cf68",
  null
  
)

export default component.exports